// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"e0cd3d57","79":"b870d68d","286":"2d4757eb","429":"22f94eca","482":"696532fb","665":"136ed630","871":"a015c71e"}[chunkId] + ".chunk.js";
};